import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';
import moment from 'moment';

const initialState = {
    editPackage: {
        packageID: {
            value: "",
            error: "",
            showError: "",
        },
        projectId: {
            value: "",
            error: "",
            showError: "",
        },
        projectName: {
            value: "",
            error: "",
            showError: "",
        },
        shippingDate: {
            value: "",
            error: "",
            showError: "",
        },
        comment: {
            value: [],
            error: "",
            showError: "",
        },
        comments: {
            value: [],
            error: "",
            showError: "",
        },
        newComment:{},
        spoolCount: 0,
        confirmPopUp: false,
        dateShift: false,
        spoolDateChange: false,
        showInput: false,
        activeTab:'1',
        commentThread:false,
        selectedFacility: {},
        selectedMaterial: {},
        isRequiredDateEditable: false,
        isScheduler: false,
        approved: false,
        packageState: "",
        typeId: "",
        revisionCheck: null,
        approvalNoteContext: null,
        approvalNoteId: null,
    },
}

const editPackage = createNamespacer("EDIT_PACKAGE")

export const editPackageReducer = createReducer(initialState.editPackage, {
    [editPackage("SET_PACKAGE_ID")]:(state, action) => {
        return {
            ...state,
            packageID: {
                ...state.packageID,
                value: action.payload.value,
            },
        }
    },
    [editPackage("SET_PROJECT_NAME")]:(state, action) => {
        return {
            ...state,
            projectName: {
                ...state.projectName,
                value: action.payload.value,
            },
        }
    },
    [editPackage("TOGGLE_TAB")]:(state,action) => {
        return {
            ...state,
            activeTab:action.payload.value,
            commentThread: true
        }
    },
    [editPackage("SET_SHOW_TEXT_INPUT")]:(state, action) => {
        return {
            ...state,
            showInput: action.payload.value,
        }
    },
    [editPackage("SET_PROJECT_ID")]:(state, action) => {
        return {
            ...state,
            projectId: {
                ...state.projectId,
                value: action.payload.value,
            },
        }
    },
    [editPackage("SET_SHIPPING_DATE")]:(state, action) => {
        return {
            ...state,
            shippingDate: {
                ...state.shippingDate,
                value: action.payload.value,
            },
        }
    },
    [editPackage("ADD_COMMENT_USERID")]:(state, action) => {
        return {
            ...state,
            newComment: {
                ...state.newComment,
                userId: action.payload.value
            }
        }
    }, 
    
    [editPackage("SET_COMMENTS")]: (state, action) => {
        return {
            ...state,
            comments: {
                ...state.comments,
                value: action.payload.updatedComments
            }
        }
       
    },
    [editPackage("SET_NEW_COMMENT")]:(state, action) => {

        return {
            ...state,
            newComment: {
                ...state.newComment,
                description: action.payload.value
            }
        }
    },
    [editPackage("LOAD_DATA")]: (state, action) => {
        const responseMapping = {
            packageID: 'package_ID',
            projectId: 'project_code',
            projectName: 'project_name',
            // comments: 'comments'
        }

        const loadedFields = _fromPairs(
            Object.entries(responseMapping).map((entry) => {
                const [key, responseKey] = entry;
                return [key, {
                    ...state[key],
                    value: action.payload.value[responseKey]
                }]
            })
        )

        return {
            ...state,
            ...loadedFields,
            shippingDate: {
                ...state.shippingDate,
                value: action.payload.date? (moment(action.payload.date)): null 
            },
            comments: {
                ...state.comments,
                value: action.payload.comments
            },
            approved: action.payload.value.fabrication && action.payload.value.fabrication.approved,
            packageState: action.payload.value.fabrication && action.payload.value.fabrication.state,
        }
    },
    [editPackage("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [editPackage("CLEAR_FORM")]: (state, action) => {
        if(state.commentThread){
            return {
                ...initialState.editPackage,
                activeTab: '2'
            }
        }else{
            return {
                ...initialState.editPackage,
            }
        }
    },
    [editPackage("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
    [editPackage("SET_SPOOL_COUNT")]: (state, action) => {
        return {
            ...state,
            spoolCount: action.payload.spoolCount
        }
    },
    [editPackage("EDIT_COMMENT")]: (state, action) => {
        return {
            ...state,
            comments: {
                ...state.comments,
                value: action.payload.comments
            }
        }
    },
    [editPackage("SET_SHOW_CONFIRM_POPUP")]: (state, action) => {
        return {
            ...state,
            confirmPopUp: action.payload.value,
        }
    },
    [editPackage("DATE_SHIFT")]: (state, action) => {
        return {
            ...state,
            dateShift: action.payload.value,
        }
    },
    [editPackage("SPOOL_DATE_CHANGE")]: (state, action) => {
        return {
            ...state,
            spoolDateChange: action.payload.value,
        }
    }, 
    [editPackage("SET_FACILITY")]: (state, action) => {
        return {
            ...state,
            selectedFacility: action.payload
        }
    },
    [editPackage("SET_MATERIAL")]: (state, action) => {
        return {
            ...state,
            selectedMaterial: action.payload
        }
    },
    [editPackage("SET_IS_REQUIRED_DATE_EDITABLE")]: (state, action) => {
        return {
            ...state,
            isRequiredDateEditable: action.payload.isRequiredDateEditable,
            isScheduler: action.payload.isScheduler,
        }
    },
    [editPackage("SET_TYPE_ID")]: (state, action) => {
        return {
            ...state,
            typeId: action.payload.typeId,
            revisionCheck: action.payload.revisionCheck,
            approvalNoteContext: action.payload.approvalNoteContext,
            approvalNoteId: action.payload.approvalNoteId,
        }
    },
})